import qs from 'qs'
import request from '@/utils/request'

// 商品分类树结构
export function goodstypeTree(params) {
    return request({
        url: '/blade-goods/goods-type/open/tree',
        method: 'get',
        params: params,
    })
}

// 轮播图
export function slideshowList(params) {
    return request({
        url: '/blade-cms/slideshow/open/list',
        method: 'get',
        params: params,
        // data: qs.stringify(params),
        // headers: {
        //     'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
        //     'Authorization':"Basic c3dvcmQ6c3dvcmRfc2VjcmV0",
        //     'Tenant-Id':"000000",
        // }
    })
}

// 产品咨询
export function productPage(params) {
    return request({
        url: '/blade-cms/article-goods/open/page',
        method: 'get',
        params: params,
    })
}
export function productDetail(params) {
    return request({
        url: '/blade-cms/article-goods/open/detail',
        method: 'get',
        params: params,
    })
}

// 品牌列表
export function brandinfoPage(params) {
    return request({
        url: '/blade-goods/brand-info/open/page',
        method: 'get',
        params: params,
    })
}
export function brandinfoList(params) {
    return request({
        url: '/blade-goods/brand-info/open/list',
        method: 'get',
        params: params,
    })
}
export function brandinfoDetail(params) {
    return request({
        url: '/blade-goods/brand-info/open/detail',
        method: 'get',
        params: params,
    })
}

// 新闻资讯
export function articleNewsList(params) {
    return request({
        url: '/blade-cms/article-news/open/list',
        method: 'get',
        params: params,
    })
}
export function articleNewspageList(params) {
    return request({
        url: '/blade-cms/article-news/open/page',
        method: 'get',
        params: params,
    })
}
export function articleNewsDetail(params) {
    return request({
        url: '/blade-cms/article-news/open/detail',
        method: 'get',
        params: params,
    })
}

//技术资料
export function articleTechnicalList(params) {
    return request({
        url: '/blade-cms/article-technical/open/list',
        method: 'get',
        params: params,
    })
}
export function articleTechnicalPage(params) {
    return request({
        url: '/blade-cms/article-technical/open/page',
        method: 'get',
        params: params,
    })
}
export function articleTechnicalDetail(params) {
    return request({
        url: '/blade-cms/article-technical/open/detail',
        method: 'get',
        params: params,
    })
}

//商品分类
export function goodsTypeList(params) {
    return request({
        url: '/blade-goods/goods-type/open/list',
        method: 'get',
        params: params,
    })
}
//商品分页列表
export function goodsInfoPage(params) {
    return request({
        url: '/blade-goods/goods-info/open/page',
        method: 'post',
        data: params,
        headers: {
            'Content-Type': 'application/json;charset=UTF-8', // application/x-www-form-urlencoded
        }
    })
}
//首页分类热门商品分页列表
export function goodsInfoHotPage(params) {
    return request({
        url: '/blade-goods/goods-info/open/hot/page',
        method: 'get',
        params: params,
    })
}

//热门商品分页列表
export function goodsHotPage(params) {
    return request({
        url: '/blade-goods/goods-hot/open/page',
        method: 'get',
        params: params,
    })
}
// 相关商品
export function groupName(params) {
    return request({
        url: '/blade-goods/goods-info/open/group-name',
        method: 'get',
        params: params,
    })
}



//友情链接
export function friendlylinkList(params) {
    return request({
        url: '/blade-cms/friendly-link/open/list',
        method: 'get',
        params: params,
    })
}

//基础设置
export function websiteConfigDetail(params) {
    return request({
        url: '/blade-cms/article-website-config/open/detail',
        method: 'get',
        params: params,
    })
}











